import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog']

  declare readonly dialogTarget: HTMLDialogElement

  open(event: Event) {
    event.preventDefault()

    this.dialogTarget.showModal()

    // prevent backdrop scrolling
    document.body.classList.add('overflow-hidden')
  }

  close(event: Event) {
    event.preventDefault()

    this.dialogTarget.close()

    // this.formTarget.reset()

    // prevent backdrop scrolling
    document.body.classList.remove('overflow-hidden')
  }

  clickOutside(event: Event) {
    if (event.target === this.dialogTarget) {
      this.close(event)
    }
  }
}
